/** @jsx jsx */
import React, { useCallback } from 'react';
import { jsx } from '@compiled/react';
import { components } from '@atlaskit/select';
import type { MenuListProps } from '@atlaskit/react-select';

import { ButtonItem, Section } from '@atlaskit/menu';
import { useIntl } from '@atlassian/jira-intl';
import { useRouterActions } from '@atlassian/react-resource-router';
import { getProjectSettingsIssueTypesUrl } from '@atlassian/jira-issue-type-config-common/src/getProjectSettingsIssueTypesUrl.tsx';
import type { Option } from '../types.tsx';
import messages from './messages.tsx';

export type MenuWithManageIssueTypesProps = MenuListProps<Option, false> & {
	children: React.ReactNode;
	projectKey: string;
	projectType?: string;
};

export const MenuWithManageIssueTypes = (props: MenuWithManageIssueTypesProps) => {
	const { formatMessage } = useIntl();
	const { push } = useRouterActions();

	const { children, projectKey, projectType, ...restProps } = props;

	// TODO: DEE-8523 Update getProjectSettingsIssueTypesUrl to handle JSW CMP
	// and pipe in projectType
	const projectSettingsUrl = getProjectSettingsIssueTypesUrl({
		projectKey,
		projectType: projectType ?? '',
	});

	const handleManageIssueTypesClick = useCallback(() => {
		push(projectSettingsUrl);
	}, [push, projectSettingsUrl]);

	const handleAddIssueTypeClick = useCallback(() => {
		// TODO: DEE-8377 Implement add issue type trigger
	}, []);

	const handleEditIssueTypeClick = useCallback(() => {
		// TODO: DEE-8378 Implement edit issue type trigger
	}, []);

	return (
		<>
			<components.MenuList {...restProps}>{children}</components.MenuList>
			<Section hasSeparator>
				<ButtonItem onClick={handleAddIssueTypeClick}>
					{formatMessage(messages.addIssueType)}
				</ButtonItem>
				<ButtonItem onClick={handleEditIssueTypeClick}>
					{formatMessage(messages.editIssueType)}
				</ButtonItem>
				<ButtonItem onClick={handleManageIssueTypesClick}>
					{formatMessage(messages.manageIssueTypes)}
				</ButtonItem>
			</Section>
		</>
	);
};
